exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".landingPageUser .label-text {\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 24px !important;\n  padding-top: 20px;\n  padding-left: 15px; }\n\n.landingPageHeader .label-text {\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 24px !important;\n  padding-top: 20px; }\n\n@media only screen and (max-width: 768px) {\n  .landing-page-main-container {\n    padding-top: 60px !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/Dashboard/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/Dashboard/index.css
// module chunks = 504